export default "__VITE_ASSET__nRFshl2$__"